import { ReactComponent as ArrowNarrowDownIcon } from "components/Icons/arrow-narrow-down.svg";
import { ReactComponent as ArrowNarrowUpIcon } from "components/Icons/arrow-narrow-up.svg";
import { ReactComponent as MinusIcon } from "components/Icons/minus.svg";
import { useStyles } from "./styles";

interface Props {
  progress: number;
}

const ProgressIndicator = ({ progress }: Props) => {
  const classes = useStyles();

  const renderProgress = () => {
    switch (true) {
      case progress === 0:
        return (
          <span
            className={`${classes.positionProgress} ${classes.positionStable}`}
          >
            0 <MinusIcon className={classes.progressIcon} />
          </span>
        );
      case progress > 0:
        return (
          <span className={`${classes.positionProgress} ${classes.positionUp}`}>
            +{progress} <ArrowNarrowUpIcon className={classes.progressIcon} />
          </span>
        );
      case progress < 0:
        return (
          <span
            className={`${classes.positionProgress} ${classes.positionDown}`}
          >
            {progress} <ArrowNarrowDownIcon className={classes.progressIcon} />
          </span>
        );
      default:
        return null;
    }
  };

  return renderProgress();
};

export default ProgressIndicator;
